var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7505 19.7163L15.0865 14.0523C16.4475 12.4183 17.1263 10.3224 16.9815 8.20075C16.8366 6.07905 15.8794 4.09486 14.3089 2.66096C12.7384 1.22705 10.6755 0.453826 8.54942 0.502135C6.42333 0.550443 4.39772 1.41657 2.89396 2.92033C1.3902 4.42408 0.524076 6.4497 0.475767 8.57579C0.427459 10.7019 1.20068 12.7647 2.63459 14.3353C4.0685 15.9058 6.05268 16.863 8.17438 17.0078C10.2961 17.1526 12.3919 16.4739 14.026 15.1128L19.69 20.7768L20.7505 19.7163ZM2.00045 8.77682C2.00045 7.4418 2.39633 6.13675 3.13803 5.02672C3.87973 3.91669 4.93394 3.05152 6.16734 2.54063C7.40074 2.02974 8.75794 1.89607 10.0673 2.15652C11.3767 2.41697 12.5794 3.05984 13.5234 4.00385C14.4674 4.94785 15.1103 6.15059 15.3708 7.45996C15.6312 8.76933 15.4975 10.1265 14.9866 11.3599C14.4757 12.5933 13.6106 13.6475 12.5006 14.3892C11.3905 15.1309 10.0855 15.5268 8.75045 15.5268C6.96085 15.5248 5.24512 14.813 3.97967 13.5476C2.71423 12.2822 2.00244 10.5664 2.00045 8.77682Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6e686530.svg";
export { ForwardRef as ReactComponent };